<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.goldlocker.title") }}</div>
    <div class="two-cards-row">
      <div class="dashboard-card recharge-history">
        <h5 class="color-gold card-title">
          {{ $t("dashboard.goldlocker.rechargeHistory") }}
        </h5>
        <div class="balance-area">
          <span class="currency">USD</span>
          <span class="balance">{{
            numberWithCommas(balanceData.balance)
          }}</span>
        </div>
        <router-link
          to="/dashboard/cash-in"
          class="btn btn-warning text-white px-4"
        >
          {{ $t("dashboard.goldlocker.recharge") }}
        </router-link>
        <div class="card-footer details">
          <router-link to="/dashboard/recharge-details">{{
            $t("dashboard.goldlocker.details")
          }}</router-link>
        </div>
      </div>
      <div class="dashboard-card events-rewards">
        <h5 class="color-blue card-title">
          {{ $t("dashboard.goldlocker.rewards") }}
        </h5>
        <div class="balance-area">
          <span class="balance">{{
            numberWithCommas(balanceData.rewards)
          }}</span>
        </div>
        <div class="card-footer details">
          <router-link to="/dashboard/rewards-details">{{
            $t("dashboard.goldlocker.details")
          }}</router-link>
        </div>
      </div>
    </div>
    <div class="three-cards-row">
      <div class="dashboard-card blue-card">
        <h5 class="color-blue card-title">
          {{ $t("dashboard.goldlocker.reserve") }}
        </h5>
        <div class="balance-area">
          <span class="balance">{{
            numberWithCommas(balanceData.reserve)
          }}</span>
        </div>
        <div class="card-footer details">
          <router-link to="/dashboard/reserve-details">{{
            $t("dashboard.goldlocker.details")
          }}</router-link>
        </div>
      </div>
      <div class="dashboard-card blue-card">
        <div class="d-flex w-100">
          <div class="w-50">
            <h5 class="color-blue card-title">
              {{ $t("dashboard.goldlocker.referGS") }}
            </h5>
            <div class="balance-area">
              <span class="balance">{{
                numberWithCommas(balanceData.referGS)
              }}</span>
            </div>
          </div>
          <div class="w-50">
            <h5 class="color-blue card-title">
              {{ $t("dashboard.goldlocker.referBiz") }}
            </h5>
            <div class="balance-area">
              <span class="balance">{{
                numberWithCommas(balanceData.referBusiness)
              }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer details">
          <router-link to="/dashboard/refer-details">{{
            $t("dashboard.goldlocker.details")
          }}</router-link>
        </div>
      </div>
      <div class="dashboard-card blue-card">
        <h5 class="color-blue card-title">
          {{ $t("dashboard.goldlocker.eventCost") }}
        </h5>
        <div class="balance-area">
          <span class="balance">{{
            numberWithCommas(balanceData.eventsCost)
          }}</span>
        </div>
        <div class="card-footer details">
          <router-link to="/dashboard/cost-details">{{
            $t("dashboard.goldlocker.details")
          }}</router-link>
        </div>
      </div>
    </div>
    <div class="transactions">
      <div class="d-md-flex justify-content-between">
        <div class="dashboard-title">
          {{ $t("dashboard.transactions.latest") }}
        </div>
        <router-link to="/dashboard/transactions">{{
          $t("dashboard.transactions.all")
        }}</router-link>
      </div>
      <b-table striped hover :items="transactions" :fields="fields"></b-table>
    </div>
  </div>
</template>

<script>
import { BTable } from "bootstrap-vue";

export default {
  components: {
    BTable,
  },
  data() {
    return {
      balanceData: {
        balance: 0,
        rewards: 0,
        reserve: 0,
        referGS: 0,
        referBusiness: 0,
        eventsCost: 0,
      },
      transactions: [
        {
          date: "",
          time: "",
          transaction: "",
          amount: "",
        },
      ],
      fields: [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取数据
      this.balanceData = {
        balance: 570,
        rewards: 8680,
        reserve: 0,
        referGS: 0,
        referBusiness: 0,
        eventsCost: 275,
      };
      this.transactions = [];
      for (let index = 0; index < 14; index++) {
        const start = new Date(2019, 0, 1);
        const end = new Date();
        const randomDate = new Date(
          start.getTime() + Math.random() * (end.getTime() - start.getTime())
        );
        const dateString =
          randomDate.getFullYear() +
          "-" +
          ("0" + (randomDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + randomDate.getDate()).slice(-2);
        const timeString =
          ("0" + randomDate.getHours()).slice(-2) +
          ":" +
          ("0" + randomDate.getMinutes()).slice(-2);
        const element = {
          date: dateString,
          time: timeString,
          transaction: "Transaction Code",
          amount: this.numberWithCommas(Math.floor(Math.random() * 10000)),
        };
        this.transactions.push(element);
      }
      // 语言切换后表格标题需要重新初始化一下
      this.fields = [
        {
          key: "date",
          label: this.$t("dashboard.transactions.date"),
          sortable: true,
        },
        {
          key: "time",
          label: this.$t("dashboard.transactions.time"),
        },
        {
          key: "transaction",
          label: this.$t("dashboard.transactions.transaction"),
        },
        {
          key: "amount",
          label: this.$t("dashboard.transactions.amount"),
          sortable: true,
        },
      ];
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style>
.dashboard-main-content {
  position: relative;
  background-color: white;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 1rem;
  width: 100%;
  .dashboard-title {
    text-align: start;
    color: #687b8e;
    font-weight: 600;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  .two-cards-row,
  .three-cards-row {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;
    .dashboard-card {
      width: 100%;
    }
  }
  .dashboard-card {
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .card-title {
      margin-bottom: 0.5rem;
      font-size: 1rem;
    }
    .balance-area {
      margin-bottom: 1rem;
      flex: 1;
      display: flex;
      justify-content: start;
      gap: 0.5rem;
      align-items: start;
      color: #406d9a;
      width: 100%;
      span {
        display: inline-block;
        vertical-align: top;
      }
      .currency {
        font-size: 1rem;
      }
      .balance {
        font-size: 2.5rem;
        line-height: 2.5rem;
        font-weight: 600;
      }
    }
    .card-footer {
      width: 100%;
      margin-top: 1rem;
      text-align: end;
      a {
        text-decoration: none;
        color: #687b8e;
        font-size: 0.75rem;
      }
    }
  }
  .recharge-history {
    background-color: #fffbf1;
  }
  .events-rewards {
    background-color: #e5f9ff;
  }
  .blue-card {
    background-color: #f3f9ff;
  }
  .transactions {
    width: 100%;
    a {
      text-decoration: none;
    }
    table {
      .sr-only {
        display: none;
      }
      thead > tr > th {
        background-color: #3586cb;
        color: white;
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .dashboard-main-content {
    .two-cards-row,
    .three-cards-row {
      flex-wrap: nowrap;
    }
  }
}
</style>
